<template>
  <div class="my-tr3-box"
       :class="{'my-tr3-box-body':trType == 'body','my-tr3-box-title':trType == 'title'}"
       ref="box"
  >
    <slot></slot>
  </div>
</template>
<script>
// <Tr1></Tr1> color:#666666; color66 color33
export default {
  name: 'Tr3',
  props: {
    trType: {
      type: String,
      default: 'body' // title
    }
  },
  data () {
    return {

    }
  },
  methods: {
    setWidth () {
      this.$nextTick(function () {
        let parantsDom = this.$refs.box
        let parantsDomWidth = window.getComputedStyle(parantsDom).width
        parantsDomWidth = parantsDomWidth.slice(0, -2)
        let childNodes = parantsDom.childNodes
        let num = 0
        for (let i = 0; i < childNodes.length; i++) {
          if (childNodes[i].nodeType === 1) {
            num++
          }
        }
        let allWidth = parantsDomWidth - (num * 2) // 可用宽度
        let innerWidth = Math.floor((allWidth / num).toFixed(0))// 子元素宽度
        //

        let childWidth = Math.floor((innerWidth / parantsDomWidth * 100))
        //
        // let childWidth = ((Number(parantsDomWidth)) / num).toFixed(0)
        // let childWidth = (1 / num * 100).toFixed(0)
        //

        // 计算差值
        let differenceValue = 100 - (childWidth * num)
        if (differenceValue >= num) {
          childWidth++
          differenceValue = differenceValue - num
        }
        //
        // )
        for (let i = 0; i < childNodes.length; i++) {
          if (childNodes[i].nodeType === 1) {
            // childNodes[i].style.width = childWidth + 'px'
            if (differenceValue > 1) {
              childNodes[i].style.width = (childWidth + 1) + '%'
              differenceValue--
            } else {
              childNodes[i].style.width = childWidth + '%'
            }
          }
        }
        this.setOverflow()
      }.bind(this))
    },
    setOverflow () {
      for (let i = 0; i < this.$children.length; i++) {
        this.$children[i].init()
      }
    }
  },
  mounted () {
    this.setWidth()
  },
  destroyed () {

  },
  updated () {
    // this.$nextTick(function () {
    //   let parantsDom = this.$refs.box
    //   let parantsDomHeight = window.getComputedStyle(parantsDom).height
    //   let childNodes = parantsDom.childNodes

    //   for (let i = 0; i < childNodes.length; i++) {
    //     if (childNodes[i].nodeType == 1) {
    //       childNodes[i].style.height = parantsDomHeight
    //     }
    //   }
    // })
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

.my-tr3-box{
  box-sizing:border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  width: 100%;
  min-height: 44px;
  border:1px solid rgba(228, 231, 237, 1);
  border-bottom:none;

  &:last-child{
    border-bottom:1px solid rgba(228, 231, 237, 1);
  }
}

.my-tr3-box-title{
  color:#333;
  background:rgba(250,250,250,1);
  font-weight:bold;
}

.my-tr3-box-body{
  color:#666;
  background:rgba(255,255,255,1);
  font-weight:400;
  &:hover{
    background:rgba(245,247,250,1);
  }
}
</style>
